import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useOrg } from 'src/contexts/OrgContext';
import LoadingBar from '../components/Reusable/LoadingBar';
import { PATH_ROOT } from 'src/routes/paths';

type OrgGuardProps = {
  children: ReactNode;
};

export default function OrgGuard({ children }: OrgGuardProps) {
  const { isInitialized, hasSelectedWorkspace } = useOrg();

  if (!isInitialized) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <LoadingBar />
      </Box>
    );
  }

  if (!hasSelectedWorkspace) {
    return <Navigate to={PATH_ROOT.organization.organizations} replace />;
  }

  return <>{children}</>;
}
